import React from 'react'
import { cn } from '@/lib/css-utils'

export const SelectItem = React.forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<'button'> & {
    inset?: boolean
    isActive?: boolean
    as?: React.ElementType
  }
>(({ className, inset, isActive, as: Component = 'button', ...props }, ref) => {
  return (
    <Component
      ref={ref}
      className={cn(
        `relative flex cursor-pointer select-none items-center gap-2 rounded-sm px-3 py-2 text-sm 
      outline-hidden transition-colors text-copy-primary
      hover:bg-dropdown-item-hover-bg hover:text-dropdown-item-hover-text
      focus:bg-dropdown-item-hover-bg focus:text-dropdown-item-hover-text
      data-disabled:pointer-events-none data-disabled:opacity-50
      [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0`,
        isActive &&
          'bg-dropdown-item-active-bg text-dropdown-item-active-text font-medium',
        inset && 'pl-8',
        className,
      )}
      {...props}
    />
  )
})

SelectItem.displayName = 'SelectItem'
